export const titles = [
	{
		value: 'Mr',
		name: 'containers.doctors.registration.titles.mr',
	},
	{
		value: 'Ms',
		name: 'containers.doctors.registration.titles.ms',
	},
	{
		value: 'Mrs',
		name: 'containers.doctors.registration.titles.mrs',
	},
	{
		value: 'Miss',
		name: 'containers.doctors.registration.titles.miss',
	},
	{
		value: 'Dr',
		name: 'containers.doctors.registration.titles.dr',
	},
	{
		value: 'Prof',
		name: 'containers.doctors.registration.titles.prof',
	},
	{
		value: 'Lady',
		name: 'containers.doctors.registration.titles.lady',
	},
	{
		value: 'Lord',
		name: 'containers.doctors.registration.titles.lord',
	},
];

export const extendedTitles = [
	{
		value: 'Mr',
		name: 'containers.doctors.registration.titles.mr',
	},
	{
		value: 'Ms',
		name: 'containers.doctors.registration.titles.ms',
	},
	{
		value: 'Mrs',
		name: 'containers.doctors.registration.titles.mrs',
	},
	{
		value: 'Miss',
		name: 'containers.doctors.registration.titles.miss',
	},
	{
		value: 'Dr',
		name: 'containers.doctors.registration.titles.dr',
	},
	{
		value: 'Prof',
		name: 'containers.doctors.registration.titles.prof',
	},
	{
		value: 'Lady',
		name: 'containers.doctors.registration.titles.lady',
	},
	{
		value: 'Lord',
		name: 'containers.doctors.registration.titles.lord',
	},
	{
		value: 'Princess',
		name: 'Princess',
	},
	{
		value: 'Master',
		name: 'Master',
	},
	{
		value: 'Prince',
		name: 'Prince',
	},
	{
		value: 'Dame',
		name: 'Dame',
	},
	{
		value: 'Sir',
		name: 'Sir',
	},
	{
		value: 'Mx',
		name: 'Mx',
	},
];

export const genders = [
	{
		value: 'male',
		label: 'globals.male',
	},
	{
		value: 'female',
		label: 'globals.female',
	},
];

export const yesNo = [
	{
		value: false,
		label: 'globals.no',
	},
	{
		value: true,
		label: 'globals.yes',
	},
];

export const codeType = [
	{
		value: 'email',
		label: 'Email',
	},
	{
		value: 'mobile',
		label: 'Mobile',
	},
];

export const scannerPreference = [
	{
		value: 1,
		label: 'forms.patientReferral.moritaAccuitomo',
		tooltip: '',
	},
	{
		value: 0,
		label: 'forms.patientReferral.kavoOP3D',
		tooltip: '',
	},
];

export const preferredPayment = [
	{
		value: 'doctor',
		label: 'Doctor Pays',
	},
	{
		value: 'patient',
		label: 'Patient Pays',
	},
];

export const intraoralAreaOfInterest = [
	{
		value: 'mandible',
		label: 'dental.mandible',
	},
	{
		value: 'maxilla',
		label: 'dental.maxilla',
	},
	{
		value: 'both_jaws',
		label: 'dental.bothJaws',
	},
];

export const bookingOptions = [
	{
		value: 'us',
		label: 'forms.createAppointment.usToArrange',
	},
	{
		value: 'patient',
		label: 'forms.createAppointment.patientWillArrange',
	},
];

export const cbctAreaOfInterest = [
	{
		value: 'sectional',
		label: 'dental.sectional',
	},
	{
		value: 'quadrant',
		label: 'dental.quadrant',
	},
	{
		value: 'mandible',
		label: 'dental.mandible',
	},
	{
		value: 'maxilla',
		label: 'dental.maxilla',
	},
	{
		value: 'bothJaws',
		label: 'dental.bothJaws',
	},
	{
		value: 'bothJawsOrtho',
		label: 'dental.bothJawsOrtho',
	},
];

export const cbctAreaOfInterest_ = [
	{
		value: 'sectional',
		label: 'dental.sectional',
	},
	{
		value: 'quadrant',
		label: 'dental.quadrant',
	},
	{
		value: 'mandible',
		label: 'dental.mandible',
	},
	{
		value: 'maxilla',
		label: 'dental.maxilla',
	},
	{
		value: 'both_jaws',
		label: 'dental.bothJaws',
	},
	{
		value: 'ortho',
		label: 'dental.bothJawsOrtho',
	},
];

export const scanner = [
	{
		value: 'Separate scans for upper jaw and lower jaw (DP700 scanner)',
		label: 'scanner.separateScansForUpperJawAndLowerJaw',
	},
	{
		value: 'Both jaws scans (MoritaF170 scanner)',
		label: 'scanner.bothJawsScans',
	},
];

//TODO - from server
export const intraoralScanningOptions = [
	{
		value: 'digital_impression',
		label: 'dental.intraoral.digitalImpression',
	},
	{
		value: 'orthodontic_aligners',
		label: 'dental.intraoral.orthodonticsAligners',
	},
	// {
	// 	value: 'radiographic_template',
	// 	label: 'dental.intraoral.radiographicTemplate',
	// },
];

export const radiographicTemplateOption = [
	{
		value: 'denture_marked',
		label: 'Denture already marked',
	},
	{
		value: 'denture_to_be_marked_by_ct_dent',
		label: 'Denture to be marked by CT Dent',
	},
	{
		value: 'separate_template',
		label: 'Separate Stent',
	},
];

// * Options for signup form starts
export const hearFrom = [
	{ value: 'Sales Rep', label: 'Sales Rep' },
	{ value: 'Colleague', label: 'Colleague' },
	{ value: 'Conference', label: 'Conference' },
	{ value: 'Magazine', label: 'Magazine' },
	{ value: 'Web search', label: 'Web search' },
	{ value: 'Social media', label: 'Social media' },
	{ value: 'Other', label: 'Other' },
];

export const pricelistDiscountArea = [
	{ value: 'all', label: 'All' },
	{ value: 'by_area', label: 'By Area' },
];
export const areaOfInterest = [
	{
		id: 1,
		value: 1,
		label: 'Sectional',
	},
	{
		id: 7,
		value: 7,
		label: 'Quadrant',
	},
	{
		id: 3,
		value: 3,
		label: 'One Jaw',
	},
	// {
	// 	id: 3,
	// 	value: 3,
	// 	label: 'Maxilla',
	// },
	{
		id: 5,
		value: 5,
		label: 'Both Jaws',
	},
	{
		id: 6,
		value: 6,
		label: 'Both Jaws (Orthognathic)',
	},
];
// * Options for signup form ends

export const paymentOptions = [
	{
		value: 'doctor',
		label: 'Doctor',
	},
	{
		value: 'patient',
		label: 'Patient',
	},
];

export const radiologyReportRangeOptions = [
	{
		value: 'appointment_date',
		label: 'Appointment date',
	},
	{
		value: 'created_at',
		label: 'Appointment created date',
	},
	{
		value: 'dyno_pr_requested_date',
		label: 'Report requested date',
	},
	{
		value: 'dyno_pr_signed_off_date',
		label: 'Report signed off date',
	},
];

export const sizeOfScanOptions = [
	{
		value: 1,
		label: '4x4',
	},
	{
		value: 2,
		label: '4x8',
	},
	{
		value: 3,
		label: '5x5',
	},
	{
		value: 4,
		label: '5x8',
	},
	{
		value: 5,
		label: '6x4',
	},
	{
		value: 6,
		label: '6x5',
	},
	{
		value: 7,
		label: '6x6',
	},
	{
		value: 8,
		label: '6x8',
	},
	{
		value: 9,
		label: '6x9',
	},
	{
		value: 10,
		label: '8x4',
	},
	{
		value: 11,
		label: '8x5',
	},
	{
		value: 12,
		label: '8x8',
	},
	{
		value: 13,
		label: '8x15',
	},
	{
		value: 14,
		label: '9x11',
	},
	{
		value: 15,
		label: '9x14',
	},
	{
		value: 16,
		label: '10x4',
	},
	{
		value: 17,
		label: '10x5',
	},
	{
		value: 18,
		label: '10x8',
	},
	{
		value: 19,
		label: '10x10',
	},
	{
		value: 20,
		label: '12x5',
	},
	{
		value: 21,
		label: '12x10',
	},
	{
		value: 22,
		label: '13x15',
	},
	{
		value: 23,
		label: '14x5',
	},
	{
		value: 24,
		label: '14x10',
	},
	{
		value: 25,
		label: '15x5',
	},
	{
		value: 26,
		label: '15x7.5',
	},
	{
		value: 27,
		label: '15x14',
	},
	{
		value: 28,
		label: '16x4',
	},
	{
		value: 29,
		label: '16x6',
	},
	{
		value: 30,
		label: '16x8',
	},
	{
		value: 31,
		label: '16x10',
	},
	{
		value: 32,
		label: '16x11',
	},
	{
		value: 33,
		label: '16x12',
	},
	{
		value: 34,
		label: '16x13',
	},
	{
		value: 35,
		label: '16x17',
	},
	{
		value: 36,
		label: '17x5',
	},
	{
		value: 37,
		label: '17x12',
	},
	{
		value: 39,
		label: '17x16',
	},
	{
		value: 40,
		label: '17x23',
	},
	{
		value: 38,
		label: '23x17',
	},
];
